// --- React
import React from "react";
// --- UI Components
import Select from "@dtci/spellbook/Select";

/**
 * EditableDropdownRenderer Component
 *
 * Cell renderer for AG Grid that shows a dropdown when in edit mode,
 * or plain text when not editing.
 *
 * @param {Array} options - Dropdown options [{label, value}]
 * @param {Function} getEditingRows - Function that returns current editing rows state
 * @param {Function} onValueChange - Callback when value changes (data, fieldName, newValue)
 * @param {string} fieldName - The field name being edited
 * @returns {Function} The cell renderer component
 */
export const EditableDropdownRenderer = (
  options,
  getEditingRows,
  onValueChange,
  fieldName,
) => {
  const Renderer = ({ value, data }) => {
    const editingRows = getEditingRows ? getEditingRows() : {};
    const isEditing = editingRows[data?.id];

    if (!isEditing) {
      return <span>{value || ""}</span>;
    }

    // Find the current option or create one from the value
    const currentOption =
      options?.find((opt) => opt.value === value || opt.label === value) ||
      (value ? { label: value, value: value } : null);

    const handleChange = (selectedOption) => {
      const newValue = selectedOption?.value || selectedOption?.label || "";
      if (onValueChange) {
        onValueChange(data, fieldName, newValue);
      }
    };

    return (
      <Select
        options={options || []}
        value={currentOption}
        onChange={handleChange}
        isClearable
        isSearchable
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          container: (base) => ({ ...base, width: "100%", minWidth: 150 }),
          control: (base) => ({ ...base, minHeight: 32 }),
          menu: (base) => ({ ...base, minWidth: 180, width: "auto" }),
          menuList: (base) => ({ ...base, maxHeight: 250 }),
        }}
      />
    );
  };

  return Renderer;
};
